
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Menu, Wifi, WifiOff, Bot, MoreVertical } from "lucide-react";
import { 
  DropdownMenu, 
  DropdownMenuContent, 
  DropdownMenuItem, 
  DropdownMenuTrigger 
} from "@/components/ui/dropdown-menu";
import { AgentListItem } from "@/types/agent";

interface ConversationHeaderProps {
  agent: AgentListItem | null;
  isConnected: boolean;
  onToggleSidebar: () => void;
  sidebarOpen: boolean;
}

export function ConversationHeader({ 
  agent, 
  isConnected, 
  onToggleSidebar, 
  sidebarOpen 
}: ConversationHeaderProps) {
  return (
    <div className="shrink-0 h-16 border-b border-border/50 bg-background/80 backdrop-blur-sm px-4 flex items-center justify-between">
      <div className="flex items-center gap-3">
        <Button
          variant="ghost"
          size="icon"
          onClick={onToggleSidebar}
          className="lg:hidden"
        >
          <Menu className="h-5 w-5" />
        </Button>
        
        <div className="flex items-center gap-3">
          <div className="h-8 w-8 rounded-full bg-primary/10 flex items-center justify-center">
            <Bot className="h-4 w-4 text-primary" />
          </div>
          
          <div className="flex flex-col">
            <h2 className="text-sm font-medium">
              {agent?.name || "AI Assistant"}
            </h2>
            <div className="flex items-center gap-2">
              <div className="flex items-center gap-1">
                {isConnected ? (
                  <Wifi className="h-3 w-3 text-green-500" />
                ) : (
                  <WifiOff className="h-3 w-3 text-red-500" />
                )}
                <span className="text-xs text-muted-foreground">
                  {isConnected ? "Connected" : "Disconnected"}
                </span>
              </div>
              {agent?.role && (
                <Badge variant="secondary" className="text-xs">
                  {agent.role}
                </Badge>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="flex items-center gap-2">
        <Badge 
          variant={isConnected ? "default" : "destructive"}
          className="text-xs"
        >
          {isConnected ? "Online" : "Offline"}
        </Badge>
        
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" size="icon" className="hidden lg:flex">
              <MoreVertical className="h-4 w-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuItem onClick={onToggleSidebar}>
              {sidebarOpen ? "Collapse Sidebar" : "Expand Sidebar"}
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </div>
  );
}
